import { axiosInstance } from '@/lib/axios';

export interface PartnerAnalyticsSummary {
  totalLeads: number;
  profileViews: number;
  bookingClicks: number;
  mapClicks: number;
  conversions: number;
  conversionRate: number;
}

export interface DayStats {
  date: string;
  leads: number;
  conversions: number;
}

export interface PartnerAnalytics {
  summary: PartnerAnalyticsSummary;
  previousSummary: PartnerAnalyticsSummary;
  dailySeries: DayStats[];
  sourceBreakdown: { source: string; count: number }[];
  period: { from: string; to: string; days: number };
}

export interface PartnerLead {
  _id: string;
  businessId: string;
  activityId?: string;
  eventType: 'profile_view' | 'map_click' | 'booking_click';
  source: 'map' | 'search' | 'list' | 'direct';
  timestamp: string;
  converted: boolean;
  bookingId?: string;
  conversionTimestamp?: string;
}

export interface PartnerLeadsResponse {
  leads: PartnerLead[];
  pagination: { page: number; limit: number; total: number; pages: number };
}

export const fetchPartnerAnalytics = (days: 7 | 30 | 90 = 30): Promise<PartnerAnalytics> =>
  axiosInstance.get(`/partner/analytics?days=${days}`).then((r) => r.data);

export const fetchPartnerLeads = (
  page = 1,
  limit = 20,
  days: 7 | 30 | 90 = 30,
): Promise<PartnerLeadsResponse> =>
  axiosInstance.get(`/partner/leads?page=${page}&limit=${limit}&days=${days}`).then((r) => r.data);
